import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { I18nextProvider } from "react-i18next";

import i18n from "./i18n";
import { router } from "./app/router";
import { SessionProvider } from "./auth/session";
import { TenantAccessGate } from "./auth/tenantAccess";
import { TenantSelectionProvider } from "./auth/tenantPicker";
import { PreferredLanguageSync } from "./profile/PreferredLanguageSync";
import "./styles.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

createRoot(rootEl).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={null}>
        <SessionProvider>
          {/* A tenant refused as a WHOLE replaces the ROUTER, not a page — frozen (decision
              f3ca7f9e) or without the application (ADR-0014 §7.1 step 3): either 403 from any call
              means no tenant-scoped surface answers, so there is no route left worth rendering and
              nowhere to navigate to. One gate for both, because the reason for being terminal is the
              same one; the two screens differ only in what they say. Inside SessionProvider, because
              the view's AuthLayout footer reads the session; outside the router, because a screen
              with no way onward should not be a route with a history entry. */}
          {/* WHICH TENANT a multi-tenant person is working in (ADR-0018 §6). Above the router because two
              things read it — the choice gate inside the route tree and the pill in the shell's top bar —
              and because the memberships read must happen once per signed-in load rather than once per
              route that happens to render a consumer. Inside SessionProvider, since the read needs a token
              and the choice is cleared when the session ends.
              ABOVE the access gate and not between it and the router: a tenant refused as a whole replaces
              the ROUTER, which is the shape tenant-access-wiring.test.mjs holds, and the picker is one of
              the things that must be replaced — a frozen organisation has no surface to choose into. */}
          <TenantSelectionProvider>
            {/* Settles the stored mail language and the UI language against each other once a session
                exists AND the tenant it is working in is settled — both directions, see
                PreferredLanguageSync. Above the router on purpose: it must run on every signed-in load,
                not only where some route happens to render it. INSIDE the selection provider, because
                `users.preferred_language` is a per-tenant row and this is therefore a tenant-scoped write:
                above the provider it would fire before a multi-tenant person had chosen, and seed the
                language in whichever tenant the token alone resolved to. The picker's gate cannot hold it
                back — that gate withholds the ROUTER, and this is not in it. */}
            <PreferredLanguageSync />
            <TenantAccessGate>
              <RouterProvider router={router} />
            </TenantAccessGate>
          </TenantSelectionProvider>
        </SessionProvider>
      </Suspense>
    </I18nextProvider>
  </StrictMode>,
);
